import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { getCheckout } from "../../services/checkoutApi";
import { useCheckoutStore } from "../../store/checkoutStore";

export const useCheckout = () => {
  const setDestinationAddress = useCheckoutStore(
    (state) => state.setDestinationAddress
  );

  const query = useQuery({
    queryKey: ["checkout"],
    queryFn: getCheckout,
    staleTime: 0,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (query.data) {
      setDestinationAddress(query.data.destination_address || null);
    }
  }, [query.data, setDestinationAddress]);

  return query;
};
